var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95732 23.0808C11.7997 23.0808 14.9146 19.9585 14.9146 16.1068C14.9146 12.2552 11.7997 9.13281 7.95732 9.13281C4.1149 9.13281 1 12.2552 1 16.1068C1 19.9585 4.1149 23.0808 7.95732 23.0808Z",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8299 7.62876C21.656 7.62876 23.1363 6.14486 23.1363 4.31438C23.1363 2.4839 21.656 1 19.8299 1C18.0038 1 16.5234 2.4839 16.5234 4.31438C16.5234 6.14486 18.0038 7.62876 19.8299 7.62876Z",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4783 19.4217C29.3044 19.4217 30.7848 17.9378 30.7848 16.1073C30.7848 14.2769 29.3044 12.793 27.4783 12.793C25.6522 12.793 24.1719 14.2769 24.1719 16.1073C24.1719 17.9378 25.6522 19.4217 27.4783 19.4217Z",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8299 30.4608C21.656 30.4608 23.1363 28.9769 23.1363 27.1464C23.1363 25.3159 21.656 23.832 19.8299 23.832C18.0038 23.832 16.5234 25.3159 16.5234 27.1464C16.5234 28.9769 18.0038 30.4608 19.8299 30.4608Z",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6188 25.7426L11.7969 21.9219",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.2993L17.3219 6.47852",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 16.1074H23.869",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/primary.8a63a30202d6496c94efb9ec30fdf312.svg";
export { ForwardRef as ReactComponent };